import { BreakpointObserver } from '@angular/cdk/layout';
import { MediaQueryService } from '@core/breakpoints';

import {
  CSGO_EXTERIORS,
  CSGO_Extras,
  Dota2ItemRarity,
  Dota2_Extras,
  Item,
  RustItemCategory,
  Rust_Extras,
  ShopCsgoExtraFilters,
  ShopDota2ExtraFilters,
  ShopExtraFilters,
  ShopRustExtraFilters,
  SteamApp
} from './items.entity';

const DEFAULT_WIDTH = 110;
// const ITEM_GAP = 5;

export function calcChunkSize(
  mediaQueryService: MediaQueryService,
  containerWidth: number,
  itemWidth: number = DEFAULT_WIDTH
): number {
  if(mediaQueryService.mediaQuery('max', 'lg')) {
    return Math.floor(containerWidth / itemWidth);
  }

  return 3;
}

export function isCsgoItem(item: Item): item is Item & { extra: CSGO_Extras } {
  return item.appId === SteamApp.CSGO;
}

export function isCsgoExtrasShopFilter(shopFilters: ShopExtraFilters): shopFilters is ShopCsgoExtraFilters {
  return 'type' in shopFilters;
}

export function getItemExterior(extras: CSGO_Extras|Dota2_Extras|Rust_Extras|null, appId: SteamApp): string {
  if(!extras) {
    return '';
  }

  if(appId === SteamApp.CSGO) {
    return CSGO_EXTERIORS[(extras as CSGO_Extras).e];
  } else if(appId === SteamApp.DOTA2) {
    const dotaExtras = extras as Dota2_Extras;

    if(!dotaExtras.r) {
      return 'Common';
    }

    return capitalize(Dota2ItemRarity[dotaExtras.r]);
  } else if(appId === SteamApp.RUST) {
    const rustExtras = extras as Rust_Extras;

    if(!rustExtras.c) {
      return '';
    }

    return capitalize(RustItemCategory[rustExtras.c]);
  }

  return '';
}

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
